/** Único dato HT editable en UI (no viene de invoice ni packing list). */

export const HT_FORM_KEY = 'ht';

export function htCertificadoNrFromFormulario(datosFormulario) {
  const ht = datosFormulario?.[HT_FORM_KEY];
  if (!ht || typeof ht !== 'object') return '';
  const raw = ht.certificadoNr;
  return raw == null ? '' : String(raw).trim();
}

/** Línea E13: «Nr.: …» */
export function formatHtCertificadoNrLine(certificadoNr) {
  const nr = certificadoNr == null ? '' : String(certificadoNr).trim();
  if (!nr) return 'Nr.:';
  if (/^Nr\.?\s*:?\s*/i.test(nr)) return nr;
  return `Nr.: ${nr}`;
}
